module.exports = __webpack_public_path__ + "media/images/logo-watermark-blue-13b84d831c0ffa261d1b666172f276d2.svg";